/**
 * Centralized app store URLs
 */
export const APP_STORE_URL = 'https://apps.apple.com/fr/app/finsly/id6757145062';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.finsly.app';
